import React, { Component } from 'react'
import View from './view'
import { connect } from 'react-redux'
import SettingIcon from '../../components/Icons/SettingIcon'
import ReportIcon from '../../components/Icons/ReportIcon copy'
import HomeIcon from '../../components/Icons/HomeIcon copy'
import { withRouter } from 'react-router-dom';




import { unSetUserInfo, toggleDrawer, toggleSnackBar } from '../../redux/actions'
import { isAllowed, ADMIN, USER, REPORTS } from '../../util';

const mapDispatchToProps = dispatch => {
  return {
    unSetUserInfo: () => dispatch(unSetUserInfo()),
    toggleDrawer: () => dispatch(toggleDrawer()),
    toggleSnackBar: () => dispatch(toggleSnackBar(""))
  };
};

const NavBarItems = [
  { label: "الرئيسية", icon: <HomeIcon hidden="hidden" />, url: "/", allowed: [USER, ADMIN], display: true },
  { label: "عجلة جديدة", icon: <HomeIcon hidden="hidden" />, url: "/car", allowed: [USER, ADMIN], display: true },
  { label: "فحص العجلات", icon: <HomeIcon hidden="hidden" />, url: "/scan", allowed: [USER, ADMIN], display: true },
  { label: "تقرير العجلات", icon: <HomeIcon hidden="hidden" />, url: "/carReport", allowed: [USER, ADMIN], display: true },
  { label: "التقارير", icon: <ReportIcon hidden="hidden" />, url: "/reports", allowed: [ADMIN, REPORTS], display: true },
  { label: "الاعدادات", icon: <SettingIcon hidden="hidden" />, url: "/settings", allowed: [ADMIN], display: true },
]

const mapStateToProps = state => {
  return {
    user: state.user,
    app: state.app,
  }
}


class index extends Component {

  constructor(props) {
    super(props)
    this.state = {
      userName: ""
    }
  }

  componentDidMount = () => {
    let { user } = this.props
    this.setState({ userName: user.user.name })
  }

  goToLogin = () => {
    let { history } = this.props;
    history.push('/login')
  }

  logout = () => {
    let { unSetUserInfo, history, toggleDrawer } = this.props;
    unSetUserInfo()
    toggleDrawer()
    history.push('/login')
  }

  goto = link => () => {
    let { history } = this.props;
    history.push(link)
    this.toggleDrawer()
  }

  createListItems = (items = []) => {
    let { user } = this.props
    if (!user.loggedIn) return [];
    return items.filter(i => isAllowed(user.user, i.allowed)).map(i => i.display ? <li key={i.url} className="flex items-center">{i.icon}<span className="lg:p-2 cursor-pointer py-2 px-0 font-semibold block border-b-2 border-transparent hover:border-vivid-700 pr-5 w-full text-grey-900" href="#" onClick={this.goto(i.url)}>{i.label}</span></li> : <li key={i.url} className="flex items-center lg:hidden">{i.icon}<span className="lg:p-3 cursor-pointer py-2 px-0 font-normal block border-b-2 border-transparent hover:border-vivid-700 pr-5 w-full text-grey-900" href="#" onClick={this.goto(i.url)}>{i.label}</span></li>)
  }

  toggleDrawer = () => {
    document.getElementById("menu-toggle").checked = false;
  }

  render() {
    let items = this.createListItems(NavBarItems)
    return (
      <div>
        <View
          {...this.state}
          toggleDrawer={this.toggleDrawer}
          items={items}
          goto={this.goto}
          logout={this.logout}
        />
      </div>
    )
  }
}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(index))